export default {
  install(Vue) {
    Vue.user = {
      storage_key: process.env.VUE_APP_LOCAL_STORAGE_KEY,

      can(permission) {
        let all = JSON.parse(localStorage.getItem(`${this.storage_key}_user_permissions`))

        return all.indexOf(permission) >= 0
      }
    };

    Object.defineProperties(Vue.prototype, {
      $user: {
        get() {
          return Vue.user;
        },
      },
    });
  },
};
